import * as React from "react";
import { makeStyles, Link } from "@fluentui/react-components";
import AgrelloLogo from "./AgrelloLogo";

const useStyles = makeStyles({
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 0",
    borderTop: "1px solid #e5e7eb",
  },
  links: {
    display: "flex",
    alignItems: "center",
    columnGap: "4px",
    fontSize: "11px",
  },
  separator: {
    color: "#9ca3af",
  },
});

const Footer: React.FC = () => {
  const styles = useStyles();

  return (
    <footer className={styles.footer}>
      <Link href="https://agrello.io" target="_blank" aria-label="Agrello">
        <AgrelloLogo width={70} height={20} />
      </Link>
      <div className={styles.links}>
        <Link href="https://www.agrello.io/en/topics/agrello-features/" target="_blank" appearance="subtle">
          Support
        </Link>
        <span className={styles.separator}>&middot;</span>
        <Link href="https://www.agrello.io/legal/terms-of-use" target="_blank" appearance="subtle">
          Terms
        </Link>
        <span className={styles.separator}>&middot;</span>
        <Link href="https://www.agrello.io/legal/privacy-policy" target="_blank" appearance="subtle">
          Privacy
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
